(function () {
  "use strict";
  /* Wade Greens - Amazon-style category tiles in the mobile menu dropdown.

     Turns the plain text links inside a dropdown into 3-across tiles with a
     square image above the label, the way the Amazon "Shop by category" grid
     reads. The label keeps the theme's own typography; only the box is new.

     TWO DIFFERENT DROPDOWN DOMS, BOTH HANDLED
     Link Row block       -> .nm-acc-body, plain <a> children, no images at all.
                             A span.wg-tile-img is inserted before the text and
                             painted as a background image.
     Image Dropdown block -> .nm-dd-body, <a class="nm-dd-card"> children that
                             already contain .nm-dd-thumb with an <img>. The
                             section renders that img at `width: 220` with no
                             height, so a landscape collection image comes
                             through landscape. Here the src is swapped for a
                             square-cropped one and the card is turned upright.

     WHERE THE IMAGES COME FROM
     Collection links  -> the handle map that snippets/wg-menu-tiles.liquid
                          prints, which prefers the custom.menu_tile metafield
                          and falls back to the collection image, always square
                          cropped by Shopify's CDN. This is why the swap matters
                          on .nm-dd-body too: the section has no idea the
                          metafield exists, so without this it renders the
                          landscape featured image instead of the swatch.
     Product links     -> /products/<handle>.js, fetched once per product and
                          cached. Only the products in a dropdown the customer
                          actually opened are fetched, so opening one costs a
                          handful of small requests and opening it again costs
                          none.
     Anything else     -> no image; the tile renders as a plain centred label
                          and still lines up with its neighbours.

     COLUMN COUNT
     The theme offers 1 or 2 columns and that option is in files over the API
     write ceiling, so a third cannot be added to the editor. "2 column" renders
     3 across on phones; "1 column" is left alone as a list. That holds for both
     block types - .nm-acc-cols-2 and .cols-2.

     Nothing is destroyed. On .nm-acc-body the original <a> keeps its href and
     its text and a span is inserted. On .nm-dd-body the original img src is
     stashed in data-wg-osrc and put back above 768px. */

  var BREAKPOINT = 768;
  var TILE_PX = 240;
  var MAP = null;
  var cache = {};
  var inflight = {};

  function tileMap() {
    if (MAP) return MAP;
    MAP = {};
    var el = document.getElementById("wg-menu-tiles");
    if (el) {
      try { MAP = JSON.parse(el.textContent || "{}") || {}; } catch (e) { MAP = {}; }
    }
    return MAP;
  }

  function handleFrom(href, kind) {
    if (!href) return null;
    var m = href.split("?")[0].split("#")[0].match(new RegExp("/" + kind + "/([^/]+)/?$"));
    return m ? m[1] : null;
  }

  /* Shopify CDN sizing is query-string based, so a square crop is three
     params. Idempotent - the map URLs already carry them. */
  function square(u) {
    if (!u) return u;
    try {
      var abs = u.indexOf("//") === 0 ? "https:" + u : u;
      var url = new URL(abs, window.location.href);
      url.searchParams.set("width", TILE_PX);
      url.searchParams.set("height", TILE_PX);
      url.searchParams.set("crop", "center");
      return url.toString();
    } catch (e) {
      return u;
    }
  }

  /* ---------- A. Link Row dropdowns: .nm-acc-body ---------- */

  function paint(a, url) {
    var holder = a.querySelector(".wg-tile-img");
    if (!holder) {
      holder = document.createElement("span");
      holder.className = "wg-tile-img";
      a.insertBefore(holder, a.firstChild);
    }
    if (url) {
      holder.style.backgroundImage = 'url("' + url.replace(/"/g, "%22") + '")';
      a.classList.remove("wg-tile-noimg");
    } else {
      a.classList.add("wg-tile-noimg");
    }
  }

  /* ---------- B. Image Dropdown cards: .nm-dd-card ---------- */

  function setThumb(thumb, url) {
    var img = thumb.querySelector("img");
    if (!img) {
      var svg = thumb.querySelector("svg");
      if (svg) svg.setAttribute("data-wg-dd-hidden", "1");
      img = document.createElement("img");
      img.setAttribute("loading", "lazy");
      img.setAttribute("alt", "");
      img.setAttribute("data-wg-dd-added", "1");
      thumb.appendChild(img);
    } else if (img.getAttribute("data-wg-osrc") === null) {
      img.setAttribute("data-wg-osrc", img.getAttribute("src") || "");
      img.setAttribute("data-wg-osrcset", img.getAttribute("srcset") || "");
      img.setAttribute("data-wg-osizes", img.getAttribute("sizes") || "");
    }
    img.removeAttribute("srcset");
    img.removeAttribute("sizes");
    img.setAttribute("src", url);
  }

  function ddProductImage(handle, thumb) {
    if (cache[handle] !== undefined) {
      if (cache[handle]) setThumb(thumb, cache[handle]);
      return;
    }
    if (inflight[handle]) { inflight[handle].push(["dd", thumb]); return; }
    inflight[handle] = [["dd", thumb]];
    fetchProduct(handle);
  }

  function acProductImage(handle, a) {
    if (cache[handle] !== undefined) { paint(a, cache[handle]); return; }
    if (inflight[handle]) { inflight[handle].push(["ac", a]); return; }
    inflight[handle] = [["ac", a]];
    fetchProduct(handle);
  }

  function flush(handle) {
    var list = inflight[handle] || [];
    var url = cache[handle];
    for (var i = 0; i < list.length; i++) {
      if (list[i][0] === "dd") { if (url) setThumb(list[i][1], url); }
      else paint(list[i][1], url);
    }
    delete inflight[handle];
  }

  function fetchProduct(handle) {
    fetch("/products/" + handle + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var img = p && p.featured_image ? p.featured_image : null;
        cache[handle] = img ? square(img) : null;
        flush(handle);
      })
      .catch(function () {
        cache[handle] = null;
        flush(handle);
      });
  }

  function ddCard(a) {
    var thumb = a.querySelector(".nm-dd-thumb");
    if (!thumb) return;
    var href = a.getAttribute("href");

    var col = handleFrom(href, "collections");
    if (col) {
      var url = tileMap()[col];
      if (url) { setThumb(thumb, url); return; }
    }

    var prod = handleFrom(href, "products");
    var existing = thumb.querySelector("img");
    if (existing) { setThumb(thumb, square(existing.getAttribute("src"))); return; }
    if (prod) { ddProductImage(prod, thumb); return; }
  }

  /* ---------- tiling / untiling ---------- */

  function tile(body, kind) {
    if (window.innerWidth >= BREAKPOINT) return;
    if (body.getAttribute("data-wg-tiled") === "1") return;
    body.setAttribute("data-wg-tiled", "1");
    body.classList.add("wg-tiled");

    if (kind === "dd") {
      var cards = body.querySelectorAll(":scope > a.nm-dd-card");
      for (var i = 0; i < cards.length; i++) ddCard(cards[i]);
      return;
    }

    var links = body.querySelectorAll(":scope > a");
    for (var j = 0; j < links.length; j++) {
      var a = links[j];
      if (a.classList.contains("nm-dd-viewall")) continue;

      var href = a.getAttribute("href");
      var col = handleFrom(href, "collections");
      if (col) { paint(a, tileMap()[col] || null); continue; }

      var prod = handleFrom(href, "products");
      if (prod) { paint(a, null); acProductImage(prod, a); continue; }

      paint(a, null);
    }
  }

  function untile(body) {
    if (body.getAttribute("data-wg-tiled") !== "1") return;
    body.removeAttribute("data-wg-tiled");
    body.classList.remove("wg-tiled");

    var imgs = body.querySelectorAll(".wg-tile-img");
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].parentNode) imgs[i].parentNode.removeChild(imgs[i]);
    }
    var noimg = body.querySelectorAll(".wg-tile-noimg");
    for (var j = 0; j < noimg.length; j++) noimg[j].classList.remove("wg-tile-noimg");

    var added = body.querySelectorAll("img[data-wg-dd-added]");
    for (var k = 0; k < added.length; k++) {
      if (added[k].parentNode) added[k].parentNode.removeChild(added[k]);
    }
    var hidden = body.querySelectorAll("svg[data-wg-dd-hidden]");
    for (var m = 0; m < hidden.length; m++) hidden[m].removeAttribute("data-wg-dd-hidden");

    var swapped = body.querySelectorAll("img[data-wg-osrc]");
    for (var n = 0; n < swapped.length; n++) {
      var img = swapped[n];
      var src = img.getAttribute("data-wg-osrc");
      var ss = img.getAttribute("data-wg-osrcset");
      var sz = img.getAttribute("data-wg-osizes");
      if (src) img.setAttribute("src", src);
      if (ss) img.setAttribute("srcset", ss);
      if (sz) img.setAttribute("sizes", sz);
      img.removeAttribute("data-wg-osrc");
      img.removeAttribute("data-wg-osrcset");
      img.removeAttribute("data-wg-osizes");
    }
  }

  function sweep() {
    var small = window.innerWidth < BREAKPOINT;
    var acc = document.querySelectorAll(".nm-acc-body");
    for (var i = 0; i < acc.length; i++) {
      if (small) tile(acc[i], "ac"); else untile(acc[i]);
    }
    var dd = document.querySelectorAll(".nm-dd-body");
    for (var j = 0; j < dd.length; j++) {
      if (small) tile(dd[j], "dd"); else untile(dd[j]);
    }
  }

  function init() {
    sweep();
    try {
      var pending = null;
      new MutationObserver(function () {
        window.clearTimeout(pending);
        pending = window.setTimeout(sweep, 80);
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
    var t = null;
    window.addEventListener("resize", function () {
      window.clearTimeout(t);
      t = window.setTimeout(sweep, 150);
    });
    document.addEventListener("shopify:section:load", function () {
      window.setTimeout(sweep, 60);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
